import * as P from "react";
import { forwardRef as Ce, useContext as Ee } from "react";
function Se(e, r) {
  const t = {
    ...r
  };
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      const a = n;
      if (a === "components" || a === "slots")
        t[a] = {
          ...e[a],
          ...t[a]
        };
      else if (a === "componentsProps" || a === "slotProps") {
        const s = e[a], i = r[a];
        if (!i)
          t[a] = s || {};
        else if (!s)
          t[a] = i;
        else {
          t[a] = {
            ...i
          };
          for (const c in s)
            if (Object.prototype.hasOwnProperty.call(s, c)) {
              const o = c;
              t[a][o] = Se(s[o], i[o]);
            }
        }
      } else t[a] === void 0 && (t[a] = e[a]);
    }
  return t;
}
function ke(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function $e(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Ae = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(a) {
      var s;
      n.tags.length === 0 ? n.insertionPoint ? s = n.insertionPoint.nextSibling : n.prepend ? s = n.container.firstChild : s = n.before : s = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(a, s), n.tags.push(a);
    }, this.isSpeedy = t.speedy === void 0 ? !0 : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag($e(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var s = ke(a);
      try {
        s.insertRule(n, s.cssRules.length);
      } catch {
      }
    } else
      a.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      var a;
      return (a = n.parentNode) == null ? void 0 : a.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), x = "-ms-", Y = "-moz-", f = "-webkit-", ue = "comm", re = "rule", te = "decl", Oe = "@import", he = "@keyframes", Pe = "@layer", Re = Math.abs, q = String.fromCharCode, Te = Object.assign;
function Ne(e, r) {
  return g(e, 0) ^ 45 ? (((r << 2 ^ g(e, 0)) << 2 ^ g(e, 1)) << 2 ^ g(e, 2)) << 2 ^ g(e, 3) : 0;
}
function de(e) {
  return e.trim();
}
function Ie(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function u(e, r, t) {
  return e.replace(r, t);
}
function Q(e, r) {
  return e.indexOf(r);
}
function g(e, r) {
  return e.charCodeAt(r) | 0;
}
function F(e, r, t) {
  return e.slice(r, t);
}
function A(e) {
  return e.length;
}
function ne(e) {
  return e.length;
}
function K(e, r) {
  return r.push(e), e;
}
function Me(e, r) {
  return e.map(r).join("");
}
var U = 1, _ = 1, le = 0, C = 0, y = 0, L = "";
function Z(e, r, t, n, a, s, i) {
  return { value: e, root: r, parent: t, type: n, props: a, children: s, line: U, column: _, length: i, return: "" };
}
function W(e, r) {
  return Te(Z("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function _e() {
  return y;
}
function Le() {
  return y = C > 0 ? g(L, --C) : 0, _--, y === 10 && (_ = 1, U--), y;
}
function S() {
  return y = C < le ? g(L, C++) : 0, _++, y === 10 && (_ = 1, U++), y;
}
function R() {
  return g(L, C);
}
function V() {
  return C;
}
function D(e, r) {
  return F(L, e, r);
}
function G(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function pe(e) {
  return U = _ = 1, le = A(L = e), C = 0, [];
}
function me(e) {
  return L = "", e;
}
function j(e) {
  return de(D(C - 1, X(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function We(e) {
  for (; (y = R()) && y < 33; )
    S();
  return G(e) > 2 || G(y) > 3 ? "" : " ";
}
function Fe(e, r) {
  for (; --r && S() && !(y < 48 || y > 102 || y > 57 && y < 65 || y > 70 && y < 97); )
    ;
  return D(e, V() + (r < 6 && R() == 32 && S() == 32));
}
function X(e) {
  for (; S(); )
    switch (y) {
      case e:
        return C;
      case 34:
      case 39:
        e !== 34 && e !== 39 && X(y);
        break;
      case 40:
        e === 41 && X(e);
        break;
      case 92:
        S();
        break;
    }
  return C;
}
function Ge(e, r) {
  for (; S() && e + y !== 57; )
    if (e + y === 84 && R() === 47)
      break;
  return "/*" + D(r, C - 1) + "*" + q(e === 47 ? e : S());
}
function ze(e) {
  for (; !G(R()); )
    S();
  return D(e, C);
}
function De(e) {
  return me(B("", null, null, null, [""], e = pe(e), 0, [0], e));
}
function B(e, r, t, n, a, s, i, c, o) {
  for (var h = 0, l = 0, m = i, T = 0, N = 0, E = 0, p = 1, w = 1, b = 1, v = 0, k = "", H = a, I = s, $ = n, d = k; w; )
    switch (E = v, v = S()) {
      case 40:
        if (E != 108 && g(d, m - 1) == 58) {
          Q(d += u(j(v), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        d += j(v);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        d += We(E);
        break;
      case 92:
        d += Fe(V() - 1, 7);
        continue;
      case 47:
        switch (R()) {
          case 42:
          case 47:
            K(He(Ge(S(), V()), r, t), o);
            break;
          default:
            d += "/";
        }
        break;
      case 123 * p:
        c[h++] = A(d) * b;
      case 125 * p:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            w = 0;
          case 59 + l:
            b == -1 && (d = u(d, /\f/g, "")), N > 0 && A(d) - m && K(N > 32 ? se(d + ";", n, t, m - 1) : se(u(d, " ", "") + ";", n, t, m - 2), o);
            break;
          case 59:
            d += ";";
          default:
            if (K($ = ae(d, r, t, h, l, a, c, k, H = [], I = [], m), s), v === 123)
              if (l === 0)
                B(d, r, $, $, H, s, m, c, I);
              else
                switch (T === 99 && g(d, 3) === 110 ? 100 : T) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    B(e, $, $, n && K(ae(e, $, $, 0, 0, a, c, k, a, H = [], m), I), a, I, m, c, n ? H : I);
                    break;
                  default:
                    B(d, $, $, $, [""], I, 0, c, I);
                }
        }
        h = l = N = 0, p = b = 1, k = d = "", m = i;
        break;
      case 58:
        m = 1 + A(d), N = E;
      default:
        if (p < 1) {
          if (v == 123)
            --p;
          else if (v == 125 && p++ == 0 && Le() == 125)
            continue;
        }
        switch (d += q(v), v * p) {
          case 38:
            b = l > 0 ? 1 : (d += "\f", -1);
            break;
          case 44:
            c[h++] = (A(d) - 1) * b, b = 1;
            break;
          case 64:
            R() === 45 && (d += j(S())), T = R(), l = m = A(k = d += ze(V())), v++;
            break;
          case 45:
            E === 45 && A(d) == 2 && (p = 0);
        }
    }
  return s;
}
function ae(e, r, t, n, a, s, i, c, o, h, l) {
  for (var m = a - 1, T = a === 0 ? s : [""], N = ne(T), E = 0, p = 0, w = 0; E < n; ++E)
    for (var b = 0, v = F(e, m + 1, m = Re(p = i[E])), k = e; b < N; ++b)
      (k = de(p > 0 ? T[b] + " " + v : u(v, /&\f/g, T[b]))) && (o[w++] = k);
  return Z(e, r, t, a === 0 ? re : c, o, h, l);
}
function He(e, r, t) {
  return Z(e, r, t, ue, q(_e()), F(e, 2, -2), 0);
}
function se(e, r, t, n) {
  return Z(e, r, t, te, F(e, 0, n), F(e, n + 1, -1), n);
}
function M(e, r) {
  for (var t = "", n = ne(e), a = 0; a < n; a++)
    t += r(e[a], a, e, r) || "";
  return t;
}
function Ke(e, r, t, n) {
  switch (e.type) {
    case Pe:
      if (e.children.length) break;
    case Oe:
    case te:
      return e.return = e.return || e.value;
    case ue:
      return "";
    case he:
      return e.return = e.value + "{" + M(e.children, n) + "}";
    case re:
      e.value = e.props.join(",");
  }
  return A(t = M(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function Ve(e) {
  var r = ne(e);
  return function(t, n, a, s) {
    for (var i = "", c = 0; c < r; c++)
      i += e[c](t, n, a, s) || "";
    return i;
  };
}
function je(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function Be(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var Ye = function(r, t, n) {
  for (var a = 0, s = 0; a = s, s = R(), a === 38 && s === 12 && (t[n] = 1), !G(s); )
    S();
  return D(r, C);
}, qe = function(r, t) {
  var n = -1, a = 44;
  do
    switch (G(a)) {
      case 0:
        a === 38 && R() === 12 && (t[n] = 1), r[n] += Ye(C - 1, t, n);
        break;
      case 2:
        r[n] += j(a);
        break;
      case 4:
        if (a === 44) {
          r[++n] = R() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += q(a);
    }
  while (a = S());
  return r;
}, Ue = function(r, t) {
  return me(qe(pe(r), t));
}, ie = /* @__PURE__ */ new WeakMap(), Ze = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, a = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !ie.get(n)) && !a) {
      ie.set(r, !0);
      for (var s = [], i = Ue(t, s), c = n.props, o = 0, h = 0; o < i.length; o++)
        for (var l = 0; l < c.length; l++, h++)
          r.props[h] = s[o] ? i[o].replace(/&\f/g, c[l]) : c[l] + " " + i[o];
    }
  }
}, Je = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
};
function be(e, r) {
  switch (Ne(e, r)) {
    case 5103:
      return f + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return f + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return f + e + Y + e + x + e + e;
    case 6828:
    case 4268:
      return f + e + x + e + e;
    case 6165:
      return f + e + x + "flex-" + e + e;
    case 5187:
      return f + e + u(e, /(\w+).+(:[^]+)/, f + "box-$1$2" + x + "flex-$1$2") + e;
    case 5443:
      return f + e + x + "flex-item-" + u(e, /flex-|-self/, "") + e;
    case 4675:
      return f + e + x + "flex-line-pack" + u(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return f + e + x + u(e, "shrink", "negative") + e;
    case 5292:
      return f + e + x + u(e, "basis", "preferred-size") + e;
    case 6060:
      return f + "box-" + u(e, "-grow", "") + f + e + x + u(e, "grow", "positive") + e;
    case 4554:
      return f + u(e, /([^-])(transform)/g, "$1" + f + "$2") + e;
    case 6187:
      return u(u(u(e, /(zoom-|grab)/, f + "$1"), /(image-set)/, f + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return u(e, /(image-set\([^]*)/, f + "$1$`$1");
    case 4968:
      return u(u(e, /(.+:)(flex-)?(.*)/, f + "box-pack:$3" + x + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + f + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return u(e, /(.+)-inline(.+)/, f + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (A(e) - 1 - r > 6) switch (g(e, r + 1)) {
        case 109:
          if (g(e, r + 4) !== 45) break;
        case 102:
          return u(e, /(.+:)(.+)-([^]+)/, "$1" + f + "$2-$3$1" + Y + (g(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~Q(e, "stretch") ? be(u(e, "stretch", "fill-available"), r) + e : e;
      }
      break;
    case 4949:
      if (g(e, r + 1) !== 115) break;
    case 6444:
      switch (g(e, A(e) - 3 - (~Q(e, "!important") && 10))) {
        case 107:
          return u(e, ":", ":" + f) + e;
        case 101:
          return u(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + f + (g(e, 14) === 45 ? "inline-" : "") + "box$3$1" + f + "$2$3$1" + x + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (g(e, r + 11)) {
        case 114:
          return f + e + x + u(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return f + e + x + u(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return f + e + x + u(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return f + e + x + e + e;
  }
  return e;
}
var Qe = function(r, t, n, a) {
  if (r.length > -1 && !r.return) switch (r.type) {
    case te:
      r.return = be(r.value, r.length);
      break;
    case he:
      return M([W(r, {
        value: u(r.value, "@", "@" + f)
      })], a);
    case re:
      if (r.length) return Me(r.props, function(s) {
        switch (Ie(s, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return M([W(r, {
              props: [u(s, /:(read-\w+)/, ":" + Y + "$1")]
            })], a);
          case "::placeholder":
            return M([W(r, {
              props: [u(s, /:(plac\w+)/, ":" + f + "input-$1")]
            }), W(r, {
              props: [u(s, /:(plac\w+)/, ":" + Y + "$1")]
            }), W(r, {
              props: [u(s, /:(plac\w+)/, x + "input-$1")]
            })], a);
        }
        return "";
      });
  }
}, Xe = [Qe], er = function(r) {
  var t = r.key;
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(p) {
      var w = p.getAttribute("data-emotion");
      w.indexOf(" ") !== -1 && (document.head.appendChild(p), p.setAttribute("data-s", ""));
    });
  }
  var a = r.stylisPlugins || Xe, s = {}, i, c = [];
  i = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(p) {
      for (var w = p.getAttribute("data-emotion").split(" "), b = 1; b < w.length; b++)
        s[w[b]] = !0;
      c.push(p);
    }
  );
  var o, h = [Ze, Je];
  {
    var l, m = [Ke, je(function(p) {
      l.insert(p);
    })], T = Ve(h.concat(a, m)), N = function(w) {
      return M(De(w), T);
    };
    o = function(w, b, v, k) {
      l = v, N(w ? w + "{" + b.styles + "}" : b.styles), k && (E.inserted[b.name] = !0);
    };
  }
  var E = {
    key: t,
    sheet: new Ae({
      key: t,
      container: i,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: s,
    registered: {},
    insert: o
  };
  return E.sheet.hydrate(c), E;
}, rr = !0;
function tr(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function(a) {
    e[a] !== void 0 ? r.push(e[a] + ";") : a && (n += a + " ");
  }), n;
}
var ye = function(r, t, n) {
  var a = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  rr === !1) && r.registered[a] === void 0 && (r.registered[a] = t.styles);
}, nr = function(r, t, n) {
  ye(r, t, n);
  var a = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var s = t;
    do
      r.insert(t === s ? "." + a : "", s, r.sheet, !0), s = s.next;
    while (s !== void 0);
  }
};
function ar(e) {
  for (var r = 0, t, n = 0, a = e.length; a >= 4; ++n, a -= 4)
    t = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      r ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var sr = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, ir = /[A-Z]|^ms/g, cr = /_EMO_([^_]+?)_([^]*?)_EMO_/g, ge = function(r) {
  return r.charCodeAt(1) === 45;
}, ce = function(r) {
  return r != null && typeof r != "boolean";
}, J = /* @__PURE__ */ Be(function(e) {
  return ge(e) ? e : e.replace(ir, "-$&").toLowerCase();
}), oe = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(cr, function(n, a, s) {
          return O = {
            name: a,
            styles: s,
            next: O
          }, a;
        });
  }
  return sr[r] !== 1 && !ge(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function z(e, r, t) {
  if (t == null)
    return "";
  var n = t;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      var a = t;
      if (a.anim === 1)
        return O = {
          name: a.name,
          styles: a.styles,
          next: O
        }, a.name;
      var s = t;
      if (s.styles !== void 0) {
        var i = s.next;
        if (i !== void 0)
          for (; i !== void 0; )
            O = {
              name: i.name,
              styles: i.styles,
              next: O
            }, i = i.next;
        var c = s.styles + ";";
        return c;
      }
      return or(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var o = O, h = t(e);
        return O = o, z(e, r, h);
      }
      break;
    }
  }
  var l = t;
  if (r == null)
    return l;
  var m = r[l];
  return m !== void 0 ? m : l;
}
function or(e, r, t) {
  var n = "";
  if (Array.isArray(t))
    for (var a = 0; a < t.length; a++)
      n += z(e, r, t[a]) + ";";
  else
    for (var s in t) {
      var i = t[s];
      if (typeof i != "object") {
        var c = i;
        r != null && r[c] !== void 0 ? n += s + "{" + r[c] + "}" : ce(c) && (n += J(s) + ":" + oe(s, c) + ";");
      } else if (Array.isArray(i) && typeof i[0] == "string" && (r == null || r[i[0]] === void 0))
        for (var o = 0; o < i.length; o++)
          ce(i[o]) && (n += J(s) + ":" + oe(s, i[o]) + ";");
      else {
        var h = z(e, r, i);
        switch (s) {
          case "animation":
          case "animationName": {
            n += J(s) + ":" + h + ";";
            break;
          }
          default:
            n += s + "{" + h + "}";
        }
      }
    }
  return n;
}
var fe = /label:\s*([^\s;{]+)\s*(;|$)/g, O;
function fr(e, r, t) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, a = "";
  O = void 0;
  var s = e[0];
  if (s == null || s.raw === void 0)
    n = !1, a += z(t, r, s);
  else {
    var i = s;
    a += i[0];
  }
  for (var c = 1; c < e.length; c++)
    if (a += z(t, r, e[c]), n) {
      var o = s;
      a += o[c];
    }
  fe.lastIndex = 0;
  for (var h = "", l; (l = fe.exec(a)) !== null; )
    h += "-" + l[1];
  var m = ar(a) + h;
  return {
    name: m,
    styles: a,
    next: O
  };
}
var ur = function(r) {
  return r();
}, ve = P.useInsertionEffect ? P.useInsertionEffect : !1, hr = ve || ur, yr = ve || P.useLayoutEffect, xe = /* @__PURE__ */ P.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ er({
    key: "css"
  }) : null
);
xe.Provider;
var dr = function(r) {
  return /* @__PURE__ */ Ce(function(t, n) {
    var a = Ee(xe);
    return r(t, a, n);
  });
}, lr = /* @__PURE__ */ P.createContext({}), we = {}.hasOwnProperty, ee = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", gr = function(r, t) {
  var n = {};
  for (var a in t)
    we.call(t, a) && (n[a] = t[a]);
  return n[ee] = r, n;
}, pr = function(r) {
  var t = r.cache, n = r.serialized, a = r.isStringTag;
  return ye(t, n, a), hr(function() {
    return nr(t, n, a);
  }), null;
}, mr = /* @__PURE__ */ dr(function(e, r, t) {
  var n = e.css;
  typeof n == "string" && r.registered[n] !== void 0 && (n = r.registered[n]);
  var a = e[ee], s = [n], i = "";
  typeof e.className == "string" ? i = tr(r.registered, s, e.className) : e.className != null && (i = e.className + " ");
  var c = fr(s, void 0, P.useContext(lr));
  i += r.key + "-" + c.name;
  var o = {};
  for (var h in e)
    we.call(e, h) && h !== "css" && h !== ee && (o[h] = e[h]);
  return o.className = i, t && (o.ref = t), /* @__PURE__ */ P.createElement(P.Fragment, null, /* @__PURE__ */ P.createElement(pr, {
    cache: r,
    serialized: c,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ P.createElement(a, o));
}), vr = mr;
const xr = "$$material";
export {
  vr as E,
  lr as T,
  xr as a,
  ye as b,
  gr as c,
  hr as d,
  tr as g,
  we as h,
  nr as i,
  Be as m,
  Se as r,
  fr as s,
  yr as u,
  dr as w
};
